import type { CryptocurrencyPayment } from "@/types/payment";
import useRequest, { disableRevalidate } from "../useRequest";
import { EscrowDeposit } from "@/types/network";
import useAccount from "@/hooks/useAccount";

export default function useDepositInfo(payment?: CryptocurrencyPayment) {
  const { address } = useAccount();
  const { data: escrowDeposit, isLoading } = useRequest<EscrowDeposit>(
    payment && payment.enableOneClick && address
      ? {
          function: "network/getDepositAmount",
          data: {
            token: {
              address: payment.tokenAddress,
              chainId: payment.chain.id,
              decimals: payment.chain.nativeCurrency.decimals,
              name: payment.chain.nativeCurrency.name,
            },
            mintType: "claimer",
            userAddress: address,
          },
          header: {
            endpoint: "network",
          },
        }
      : null,
    {
      ...disableRevalidate,
    }
  );

  return {
    amount: escrowDeposit?.tokenAmount || 0,
    contractAddress: escrowDeposit?.escrowContractAddress,
    isLoading,
    info: escrowDeposit,
  };
}
